var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarretleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9209 12.2441C4.93164 11.8037 5.08203 11.4385 5.43652 11.0947L13.708 3.00586C13.9766 2.72656 14.3096 2.59766 14.7178 2.59766C15.5234 2.59766 16.168 3.23145 16.168 4.03711C16.168 4.43457 16.0068 4.7998 15.7168 5.08984L8.36914 12.2334L15.7168 19.3984C16.0068 19.6885 16.168 20.043 16.168 20.4512C16.168 21.2568 15.5234 21.9014 14.7178 21.9014C14.3203 21.9014 13.9766 21.7617 13.708 21.4824L5.43652 13.3936C5.08203 13.0498 4.9209 12.6846 4.9209 12.2441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretleft);
export default __webpack_public_path__ + "static/media/carret.left.623584cd689a8df533e599d3c20fb509.svg";
export { ForwardRef as ReactComponent };